import styled from 'styled-components/native';

export const Container = styled.View`
	padding: 1rem 3rem;
	justify-content: center;
	gap: 1rem;
`;

export const Content = styled.View`
`;